<template>
  <modal
    v-model="modalVisible"
    :title="$attrs.title"
    :footer="false"
    :header-close-button="false"
    @closed="onClose"
  >
    <button id="close" slot="before-content" @click.prevent="onClose">
      <i class="af-icons af-icons-cross"></i>
    </button>
    <comment
      v-for="comment in comments"
      :key="comment.slug"
      :comment="comment"
    />
  </modal>
</template>

<script>
import Comment from '../Comments/Comment.vue';
import { Modal } from 'vue-bootstrap';

/**
 * The CommentModal component.
 */
export default {
  components: {
    Comment,
    Modal
  },
  inheritAttrs: false,
  model: {
    prop: 'visibility',
    event: 'change'
  },
  props: {
    visibility: {
      type: Boolean,
      default: false
    },
    comments: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      modalVisible: this.visibility
    };
  },
  watch: {
    visibility() {
      this.modalVisible = this.visibility;
    }
  },
  methods: {
    onClose() {
      this.modalVisible = false;
      this.$emit('change', this.modalVisible);
    }
  }
};
</script>
